import React, { useState, useEffect, useRef } from 'react';
import { Field, Formik, Form } from 'formik';
import AddEditTeamDialog from "./AddEditTeamDialog";
import * as Yup from 'yup';
import { RenderIf } from "../../../../components";
import LoggedInUserService from "../../../../services/AuthService";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { TextInput, Checkbox1 } from '../../../../components';

const AddEditUserForm = ({ onSubmit, onCancel, isSubmittingForm, selectedUser }) => {
    const [teams, setTeams] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedTeams, setSelectedTeams] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const { postData, getData } = useAxios()

    const dropdownRef = useRef(null);

    const filteredItems = teams.filter(
        (item) =>
            item.name.toLowerCase().includes(search.toLowerCase()) &&
            !selectedTeams.some((selected) => selected._id === item._id)
    );

    useEffect(() => {
        if (selectedUser && selectedUser.teamIds?.length > 0 && teams?.length > 0) {
            const selectedTeamObjects = selectedUser.teamIds
                .map(id => teams.find(team => team._id === id))
                .filter(Boolean);
    
            setSelectedTeams(selectedTeamObjects);
        }
    }, [selectedUser, teams]);

    useEffect(() => {
        const handleClickOutside = e => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        fetchTeamsData();
    }, []);

    const fetchTeamsData = async () => {
        await getData(Constants.ApiUrl.team.getTeams).then(resp => {
            if (resp.success) {
                setTeams(resp.data.teams);
            }
        }).catch(err => {
        })
    }

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('First name is required'),
        lastName: Yup.string().required('Last name is required'),
        email: Yup.string().required('Email is required').email('Please enter a valid email'),
        mobileNumber: Yup.string().required('Mobile number is required'),
        password: selectedUser
            ? Yup.string().min(8, 'Password must be at least 8 characters long').nullable()
            : Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long'),

        confirmPassword: Yup.string()
            .when('password', {
                is: (password) => !!password,
                then: (schema) => schema
                    .required('Confirm password is required')
                    .oneOf([Yup.ref('password')], 'Passwords must match'),
                otherwise: (schema) => schema.notRequired()
            }),
    })

    return (
        <>
                <Formik
            initialValues={{
                firstName: selectedUser ? selectedUser?.firstName : '',
                lastName: selectedUser ? selectedUser?.lastName : '',
                email: selectedUser ? selectedUser?.email : '',
                mobileNumber: selectedUser ? selectedUser?.mobileNumber : '',
                password: '',
                confirmPassword: '',
                isAdmin: selectedUser ? selectedUser?.isAdmin : false,
                teamIds: selectedUser ? selectedTeams : []
            }}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { setErrors }) => {
                const payload = {
                    ...values,
                    teamIds: values.teamIds.map(team => team._id), // <-- only send _id
                };
                onSubmit(true, payload, setErrors, selectedUser);
            }}
        >
            {() => (
                <Form>
                    <div className="add-form p-0">
                        <div className="p-4">
                            <div className="row pt-3">
                                <div className="col-6">
                                    <div className="form-group">
                                        <Field name="firstName" placeholder="Enter First Name" label="First Name" component={TextInput} />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <Field name="lastName" placeholder="Enter Last Name" label="Last Name" component={TextInput} />
                                    </div>
                                </div>



                                <div className="col-6">
                                    <div className="form-group">
                                        <Field name="email" placeholder="Enter Email" label="Email" component={TextInput} />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <Field name="mobileNumber" placeholder="Enter Mobile Number" label="Mobile Number" component={TextInput} />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <Field name="password" type="password" placeholder="Enter Password" label="Password" component={TextInput} />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <Field name="confirmPassword" type="password" placeholder="Confirm Password" label="Confirm Password" component={TextInput} />
                                    </div>
                                </div>
                                    <div className="col-12">
                                        <div
                                            className="flex flex-wrap gap-2 px-2 py-1 border rounded"
                                        >
                                            <Field name="teamIds">
                                                {({ field, form }) => (
                                                    <div className="form-group">
                                                        <label className="label-style">Teams</label>
                                                        <div ref={dropdownRef}>
                                                            <input
                                                                className="input-field-style"
                                                                placeholder="Search or add..."
                                                                value={search}
                                                                onFocus={() => setShowDropdown(true)}
                                                                onChange={(e) => {
                                                                    setSearch(e.target.value);
                                                                    setShowDropdown(true);
                                                                }}
                                                            />
                                                            {showDropdown && (
                                                                <div className="absolute mt-1 bg-white border rounded z-10">
                                                                    {filteredItems.length > 0 ? (
                                                                        filteredItems.map((item, idx) => {
                                                                            const isSelected = field?.value?.some(
                                                                                (team) => team._id === item._id
                                                                            );
                                                                            return (
                                                                                <div
                                                                                    key={idx}
                                                                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer multi-select-dropdown d-flex align-items-center"
                                                                                    onClick={() => {
                                                                                        const currentValue = Array.isArray(field.value) ? field.value : [];
                                                                                        const isSelected = currentValue.some(team => team._id === item._id);

                                                                                        const newSelection = isSelected
                                                                                            ? currentValue.filter(team => team._id !== item._id)
                                                                                            : [...currentValue, item];

                                                                                        form.setFieldValue("teamIds", newSelection);
                                                                                    }}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="me-2"
                                                                                        checked={isSelected}
                                                                                        readOnly
                                                                                    />
                                                                                    <span>{item.name}</span>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    ) : (
                                                                        <div className="px-4 py-2">No matches found.</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="d-flex flex-wrap gap-2 mt-2">
                                                            {field?.value?.map((team, id) => (
                                                                <div
                                                                    key={id}
                                                                    className="badge bg-secondary text-white d-flex align-items-center">
                                                                    {team.name}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            const updated = field.value.filter((t) => t._id !== team._id);
                                                                            form.setFieldValue("teamIds", updated);
                                                                        }}
                                                                        className="btn btn-sm btn-light ms-2">
                                                                        <i className="fa fa-times text-dark" />
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                <div className="col-12 mt-3">
                                    <div className="form-group">
                                        <Field
                                            name="isAdmin"
                                            label="Admin"
                                            position="left"
                                            component={Checkbox1}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button onClick={onCancel} type="button" className="btn btn-theme btn-border">
                                        Cancel
                                    </button>
                                    <button disabled={isSubmittingForm} type="submit" className="btn btn-theme">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
        </>
    )
}

export default AddEditUserForm;